import React from "react";
import BannerImage from "./BannerImage";

const VisionandMissionContent = ({
  node,
  baseUrl,
  imageData,
  currentLanguage,
}) => {
  const { title, bannerImage, visionAndMissionPoint } = node;
  return (
    <div className="relative z-0">
      <BannerImage imageUrl={`${bannerImage.url}`} />
      <div className="container mx-auto px-4 md:px-8 lg:px-12 xl:px-20 max-w-screen-xl">
        <h1 className="text-2xl sm:text-xl lg:text-3xl font-heading font-bold uppercase relative text-indian-red text-center section-heading">
          {title}
          <div className="relative flex items-center justify-center line-with-image">
            <img
              src="/assets/SHIKSHA_Flower_SVG.svg"
              alt="headingflower"
              className="h-7 sm:h-6 lg:h-9 p-1 sm:p-2"
            />
          </div>
        </h1>
        <ul className="box-border">
  {visionAndMissionPoint.map((point, index) => (
    <li
      key={index}
      className="flex flex-col sm:flex-row items-start sm:items-center mb-6 sm:mb-8 lg:mb-10"
    >
      <figure
  className="
    flex items-center justify-center
    w-[120px] h-[120px]
    bg-white
    border border-indian-red
    rounded-full
    shadow-md
    overflow-hidden
    mr-0 sm:mr-6
  "
>
  <img
    src={point.iconWithWorkingModelPo.url}
    alt={point.iconWithWorkingModelPo.alt}
    className="max-w-[70px] max-h-[70px] object-contain"
  />
</figure>



      <div className="lg:w-[80%] sm:w-[65%] mt-4 sm:mt-0">
        <p className="text-sm sm:text-base lg:text-lg">
          <strong className="font-bold font-body text-indian-red mb-2 block text-lg sm:text-xl lg:text-2xl">
            {point.pointsTitle}
          </strong>
          <span className="text-sm font-body sm:text-base text-justify">
            {point.pointsDescription}
          </span>
        </p>
      </div>
    </li>
  ))}
</ul>

      </div>
    </div>
  );
};

export default VisionandMissionContent;
